import { getStaticProps, default as RenderComponent } from "./404";
export { getStaticProps };
export default RenderComponent;
